import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getBusinessContacts = async (
  businessId,
  activeEmployerInfo = {}
) => {
  const apiPath = `contacts/business/${businessId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
